import React, { useMemo } from 'react';
import history from 'services/history';

import {
  List,
  ListItem,
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  Box,
} from '@material-ui/core';

import { DropMenu } from 'components';

import useStyle from './styles';

export const TableOptionId = Object.freeze({
  START_SERVICE: 'startService',
  ADD_PRODUCT: 'addProduct',
  SHOW_REQUEST: 'showRequest',
});
const TableStatus = Object.freeze({
  AVAILABLE: 'available',
  IN_PROGRESS: 'orderInProgress',
  BUSY: 'busy',
});

const TABLE_OPTIONS = [
  {
    id: TableOptionId.START_SERVICE,
    label: 'INICIAR ATENDIMENTO',
  },
  {
    id: TableOptionId.ADD_PRODUCT,
    label: 'ADICIONAR PRODUTO',
  },
  {
    id: TableOptionId.SHOW_REQUEST,
    label: 'VER PEDIDO',
  },
];

export default function SquareTable({ type, table, onClickOption }) {
  const classes = useStyle();

  const tableStatus = useMemo(() => {
    switch (type) {
      case TableStatus.AVAILABLE:
        return {
          label: 'Disponível',
          id: TableStatus.AVAILABLE,
        };
      case TableStatus.IN_PROGRESS:
        return {
          label: 'Mesa em andamento',
          id: TableStatus.IN_PROGRESS,
        };
      default:
        return {
          label: 'Ocupado',
          id: TableStatus.BUSY,
        };
    }
  }, [type]);

  const options = useMemo(() => {
    if (tableStatus.id === TableStatus.IN_PROGRESS) {
      return TABLE_OPTIONS.filter(
        (option) => option.id !== TableOptionId.START_SERVICE,
      );
    }
    return TABLE_OPTIONS;
  }, [tableStatus]);

  const handleOpenDropMenu = () => {
    history.push(`?table=${table.id}`);
  };

  const handleClickOption = (option) => {
    // todo: close tooltip
    onClickOption(option);
  };

  return (
    <Card className={[classes[type]]}>
      <CardContent className={classes.content}>
        <Box className={classes.iconButton}>
          <DropMenu onOpen={handleOpenDropMenu}>
            <List>
              {options.map((option) => (
                <ListItem key={option.id}>
                  <Button onClick={() => handleClickOption(option)}>
                    {option.label}
                  </Button>
                </ListItem>
              ))}
            </List>
          </DropMenu>
        </Box>

        <Typography variant="h3" className={classes.text}>
          {table.number}
        </Typography>
      </CardContent>

      <CardActions className={classes.action}>
        <Typography className={classes.text} variant="subtitle2">
          {tableStatus.label}
        </Typography>
      </CardActions>
    </Card>
  );
}
